/** Arrangement. */
export enum Arrangement {
  Multiple = 'multiple',
  Single = 'single'
}
